import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class QueryService {
  private readonly baseUrl = 'queryUrl/namespace/kb/sparql';
  private readonly baseUrlQuery = 'apiUrl/omnis/lod/queryExamples';

  constructor(private http: HttpClient) {
  }

  public sendQuery(query: string) {
    let queryParam = 'query=' + query;
    queryParam = queryParam.replace(/(\r\n|\n|\r|\t)/gm, "");
    const headers = new HttpHeaders().append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8').append('Accept', 'application/sparql-results+json')
    return this.http.post<any>(this.baseUrl , queryParam ,{headers: headers});
  }

  public getQueryExamples() {
    return this.http.get<any>(this.baseUrlQuery);
  }
}
